import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import ChatApp from './ChatApp';
import { Helmet } from 'react-helmet-async';
import chatFavicon from "../assets/favicon/favicon.ico";
const ChatAppManagement = () => {
  return (
    <>
      <Helmet>
        <title>Live Chat | WhatGrowPro</title>
        <meta
          name="description"
          content="Manage real-time customer conversations using WhatGrowPro’s Live Chat — connect instantly and improve customer satisfaction."
        />
        <meta name="keywords" content="Live Chat, WhatsApp automation, customer support, WhatGrowPro" />
        <link rel="icon" type="image/png" href={chatFavicon} />
      </Helmet>
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar: fixed height, non-scrollable */}
      <div className="h-screen  bg-gray-100 flex-shrink-0">
        <Sidebar />
      </div>

      {/* Main content: scrollable */}
      <div className="flex-1 overflow-y-auto bg-gray-100">
        <div className="p-">
          <ChatApp />
        </div>
      </div>
    </div>
    </>
  );
};

export default ChatAppManagement;
